<template>
<div class="chapter">
<div class="inner_page">
<div class="ipadfp"><img alt="Samurai Girl: Book One: The Book of the Sword, by Carrie Asai. Simon Pulse. New York | London | Toronto | Sydney | Singapore." class="imagefp" role="doc-cover" src="e9781416503712/images/9781416503712.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?0c005c3c